import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SchemaField from './SchemaField';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove
} from 'react-sortable-hoc';
import styles from '../../Form.scss';

// eslint-disable-next-line new-cap
const DragHandle = SortableHandle(() =>
  <div className={styles.dragHandleContainer}>
    <div className={styles.dragHandle} />
  </div>
);

// eslint-disable-next-line new-cap
const SortableItem = SortableElement(
  ({
    objectKey,
    schema,
    uiSchema,
    updateForm,
    deleteQuestion,
    deleteResponse,
    onChange,
    formData
  }) =>
    <div
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      <DragHandle />
      <div style={{ flex: 1 }}>
        <SchemaField
          key={objectKey}
          objectKey={objectKey}
          schema={schema.properties[objectKey]}
          uiSchema={uiSchema[objectKey]}
          onChange={(value, callback) => onChange(value, objectKey, callback)}
          updateForm={updateForm}
          formData={formData && formData[objectKey]}
          deleteQuestion={deleteQuestion}
          deleteResponse={(callback) => deleteResponse(objectKey, callback)}
        />
      </div>
    </div>
);

// eslint-disable-next-line new-cap
const SortableList = SortableContainer(
  ({
    items,
    onChange,
    schema,
    uiSchema,
    updateForm,
    formData,
    deleteQuestion,
    deleteResponse
  }) =>
    <div>
      {items.map((key, index) =>
        <SortableItem
          key={key}
          objectKey={key}
          onChange={onChange}
          formData={formData}
          index={index}
          schema={schema}
          uiSchema={uiSchema}
          updateForm={updateForm}
          deleteQuestion={deleteQuestion}
          deleteResponse={deleteResponse}
        />
      )}
    </div>
);

export default class ObjectField extends React.Component {
  static propTypes = {
    formData: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object,
    updateForm: PropTypes.func.isRequired,
    deleteQuestion: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.deleteResponse = this.deleteResponse.bind(this);
  }

  onChange(value, key, callback) {
    const schema = _.cloneDeep(this.props.schema);
    const uiSchema = _.cloneDeep(this.props.uiSchema);
    const formData = _.cloneDeep(this.props.formData);
    schema.properties[key] = value.schema;
    uiSchema[key] = value.uiSchema;
    if (formData) {
      formData[key] = value.formData;
    }
    this.props.onChange({ schema, uiSchema, formData }, callback);
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const uiSchema = _.cloneDeep(this.props.uiSchema);
    const { schema, formData } = this.props;
    uiSchema['ui:order'] = arrayMove(uiSchema['ui:order'], oldIndex, newIndex);
    this.props.onChange({ schema, uiSchema, formData }, this.props.updateForm);
  };

  deleteResponse(key, callback) {
    const formData = _.cloneDeep(this.props.formData);
    const { schema, uiSchema } = this.props;
    if (formData) {
      delete formData[key];
    }
    this.props.onChange({ formData, schema, uiSchema }, callback);
  }

  render() {
    const {
      schema,
      uiSchema,
      updateForm,
      formData,
      deleteQuestion
    } = this.props;
    const orderedKeys = uiSchema['ui:order'] || Object.keys(schema.properties);

    return (
      <SortableList
        items={orderedKeys}
        onSortEnd={this.onSortEnd}
        onChange={this.onChange}
        useDragHandle
        schema={schema}
        uiSchema={uiSchema}
        updateForm={updateForm}
        formData={formData}
        deleteQuestion={deleteQuestion}
        deleteResponse={this.deleteResponse}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/Fields/Object.js